import EditProfile from "./editProfile.organism";

export default EditProfile;
